"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.initializeDashboardHandler = void 0;
var tslib_1 = require("tslib");
var effects_1 = require("redux-saga/effects");
var dashboard_1 = require("../../../events/dashboard");
var loading_1 = require("../../../store/loading");
var sdk_backend_spi_1 = require("@gooddata/sdk-backend-spi");
var resolveDashboardConfig_1 = require("./resolveDashboardConfig");
var config_1 = require("../../../store/config");
var entitlements_1 = require("../../../store/entitlements");
var dateFilterConfig_1 = require("../../../store/dateFilterConfig");
var mergeDateFilterConfigs_1 = require("./mergeDateFilterConfigs");
var resolvePermissions_1 = require("./resolvePermissions");
var permissions_1 = require("../../../store/permissions");
var loadCatalog_1 = require("./loadCatalog");
var loadDashboardAlerts_1 = require("./loadDashboardAlerts");
var catalog_1 = require("../../../store/catalog");
var alerts_1 = require("../../../store/alerts");
var redux_batched_actions_1 = require("redux-batched-actions");
var loadUser_1 = require("./loadUser");
var user_1 = require("../../../store/user");
var ui_1 = require("../../../store/ui");
var renderMode_1 = require("../../../store/renderMode");
var loadDashboardList_1 = require("./loadDashboardList");
var listedDashboards_1 = require("../../../store/listedDashboards");
var backendCapabilities_1 = require("../../../store/backendCapabilities");
var sdk_model_1 = require("@gooddata/sdk-model");
var stateInitializers_1 = require("../common/stateInitializers");
var executionResults_1 = require("../../../store/executionResults");
var displayFormMap_1 = require("../../../../_staging/catalog/displayFormMap");
var contexts_1 = require("../../../store/_infra/contexts");
var accessibleDashboards_1 = require("../../../store/accessibleDashboards");
var loadAccessibleDashboardList_1 = require("./loadAccessibleDashboardList");
var loadLegacyDashboards_1 = require("./loadLegacyDashboards");
var legacyDashboards_1 = require("../../../store/legacyDashboards");
var uniqBy_1 = tslib_1.__importDefault(require("lodash/uniqBy"));
var loadDashboardPermissions_1 = require("./loadDashboardPermissions");
var dashboardPermissions_1 = require("../../../store/dashboardPermissions");
var resolveEntitlements_1 = require("./resolveEntitlements");
function loadDashboardFromBackend(ctx, privateCtx, dashboardRef, hasPersistedDashboard) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var backend, workspace, filterContextRef, preloadedDashboard, insights;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    backend = ctx.backend, workspace = ctx.workspace, filterContextRef = ctx.filterContextRef;
                    preloadedDashboard = privateCtx.preloadedDashboard;
                    if (!(preloadedDashboard && sdk_model_1.areObjRefsEqual(preloadedDashboard.ref, dashboardRef))) return [3 /*break*/, 3];
                    if (!hasPersistedDashboard) return [3 /*break*/, 2];
                    return [4 /*yield*/, loadInsightsForPersistedDashboard(ctx, preloadedDashboard)];
                case 1:
                    insights = _a.sent();
                    return [2 /*return*/, {
                            dashboard: preloadedDashboard,
                            references: {
                                insights: insights,
                                plugins: [],
                            },
                        }];
                case 2: return [2 /*return*/, backend
                        .workspace(workspace)
                        .dashboards()
                        .getDashboardReferencedObjects(preloadedDashboard, ["insight"])
                        .then(function (references) {
                        return {
                            dashboard: preloadedDashboard,
                            references: references,
                        };
                    })];
                case 3: return [2 /*return*/, backend
                        .workspace(workspace)
                        .dashboards()
                        .getDashboardWithReferences(dashboardRef, filterContextRef, { loadUserData: true }, ["insight"])];
            }
        });
    });
}
function loadInsightsForPersistedDashboard(ctx, dashboard) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var backend, workspace, referencedInsights, uniqueRefs;
        return tslib_1.__generator(this, function (_a) {
            if (!(dashboard === null || dashboard === void 0 ? void 0 : dashboard.layout)) {
                return [2 /*return*/, []];
            }
            backend = ctx.backend, workspace = ctx.workspace;
            referencedInsights = [];
            sdk_backend_spi_1.walkLayout(dashboard.layout, {
                widgetCallback: function (widget) {
                    if (sdk_model_1.isInsightWidget(widget)) {
                        referencedInsights.push.apply(referencedInsights, tslib_1.__spread([
                            // insight itself
                            widget.insight], widget.drills.filter(sdk_model_1.isDrillToInsight).map(function (drill) { return drill.target; })));
                    }
                },
            });
            uniqueRefs = uniqBy_1.default(referencedInsights, sdk_model_1.serializeObjRef);
            return [2 /*return*/, Promise.all(uniqueRefs.map(function (ref) { return backend.workspace(workspace).insights().getInsight(ref); }))];
        });
    });
}
function loadExistingDashboard(ctx, cmd, dashboardRef) {
    var backend, privateCtx, _a, dashboardWithReferences, config, permissions, entitlements, catalog, alerts, user, listedDashboards, accessibleDashboards, legacyDashboards, dashboardPermissions, dashboard, insights, effectiveDateFilterConfig, initActions, batch, event;
    return tslib_1.__generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                backend = ctx.backend;
                return [4 /*yield*/, effects_1.call(contexts_1.getPrivateContext)];
            case 1:
                privateCtx = _b.sent();
                return [4 /*yield*/, effects_1.all([
                        effects_1.call(loadDashboardFromBackend, ctx, privateCtx, dashboardRef, !!cmd.payload.persistedDashboard),
                        effects_1.call(resolveDashboardConfig_1.resolveDashboardConfig, ctx, cmd),
                        effects_1.call(resolvePermissions_1.resolvePermissions, ctx, cmd),
                        effects_1.call(resolveEntitlements_1.resolveEntitlements, ctx),
                        effects_1.call(loadCatalog_1.loadCatalog, ctx),
                        effects_1.call(loadDashboardAlerts_1.loadDashboardAlerts, ctx),
                        effects_1.call(loadUser_1.loadUser, ctx),
                        effects_1.call(loadDashboardList_1.loadDashboardList, ctx),
                        effects_1.call(loadAccessibleDashboardList_1.loadAccessibleDashboardList, ctx),
                        effects_1.call(loadLegacyDashboards_1.loadLegacyDashboards, ctx),
                        effects_1.call(loadDashboardPermissions_1.loadDashboardPermissions, ctx),
                    ])];
            case 2:
                _a = tslib_1.__read.apply(void 0, [_b.sent(), 11]), dashboardWithReferences = _a[0], config = _a[1], permissions = _a[2], entitlements = _a[3], catalog = _a[4], alerts = _a[5], user = _a[6], listedDashboards = _a[7], accessibleDashboards = _a[8], legacyDashboards = _a[9], dashboardPermissions = _a[10];
                dashboard = dashboardWithReferences.dashboard, insights = dashboardWithReferences.references.insights;
                return [4 /*yield*/, effects_1.call(mergeDateFilterConfigs_1.mergeDateFilterConfigWithOverrides, ctx, cmd, config.dateFilterConfig, dashboard.dateFilterConfig)];
            case 3:
                effectiveDateFilterConfig = _b.sent();
                return [4 /*yield*/, effects_1.call(stateInitializers_1.actionsToInitializeExistingDashboard, ctx, dashboard, insights, config.settings, effectiveDateFilterConfig.config, displayFormMap_1.createDisplayFormMapFromCatalog(catalog), cmd.payload.persistedDashboard)];
            case 4:
                initActions = _b.sent();
                batch = redux_batched_actions_1.batchActions(tslib_1.__spread([
                    backendCapabilities_1.backendCapabilitiesActions.setBackendCapabilities(backend.capabilities),
                    config_1.configActions.setConfig(config),
                    entitlements_1.entitlementsActions.setEntitlements(entitlements),
                    user_1.userActions.setUser(user),
                    permissions_1.permissionsActions.setPermissions(permissions),
                    catalog_1.catalogActions.setCatalogItems({
                        attributes: catalog.attributes(),
                        dateDatasets: catalog.dateDatasets(),
                        facts: catalog.facts(),
                        measures: catalog.measures(),
                    })
                ], initActions, [
                    alerts_1.alertsActions.setAlerts(alerts),
                    dateFilterConfig_1.dateFilterConfigActions.setDateFilterConfig({
                        dateFilterConfig: dashboard.dateFilterConfig,
                        effectiveDateFilterConfig: effectiveDateFilterConfig.config,
                        isUsingDashboardOverrides: effectiveDateFilterConfig.source === "dashboard",
                    }),
                    listedDashboards_1.listedDashboardsActions.setListedDashboards(listedDashboards),
                    accessibleDashboards_1.accessibleDashboardsActions.setAccessibleDashboards(accessibleDashboards),
                    legacyDashboards_1.legacyDashboardsActions.setLegacyDashboards(legacyDashboards),
                    ui_1.uiActions.setMenuButtonItemsVisibility(config.menuButtonItemsVisibility),
                    renderMode_1.renderModeActions.setRenderMode(config.initialRenderMode),
                    dashboardPermissions_1.dashboardPermissionsActions.setDashboardPermissions(dashboardPermissions),
                ]), "@@GDC.DASH/BATCH.INIT.EXISTING");
                event = dashboard_1.dashboardInitialized(ctx, dashboard, insights, config, permissions, cmd.correlationId);
                return [2 /*return*/, {
                        batch: batch,
                        event: event,
                    }];
        }
    });
}
function initializeNewDashboard(ctx, cmd) {
    var backend, _a, config, permissions, entitlements, catalog, user, listedDashboards, accessibleDashboards, legacyDashboards, batch, event;
    return tslib_1.__generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                backend = ctx.backend;
                return [4 /*yield*/, effects_1.all([
                        effects_1.call(resolveDashboardConfig_1.resolveDashboardConfig, ctx, cmd),
                        effects_1.call(resolvePermissions_1.resolvePermissions, ctx, cmd),
                        effects_1.call(resolveEntitlements_1.resolveEntitlements, ctx),
                        effects_1.call(loadCatalog_1.loadCatalog, ctx),
                        effects_1.call(loadUser_1.loadUser, ctx),
                        effects_1.call(loadDashboardList_1.loadDashboardList, ctx),
                        effects_1.call(loadAccessibleDashboardList_1.loadAccessibleDashboardList, ctx),
                        effects_1.call(loadLegacyDashboards_1.loadLegacyDashboards, ctx),
                    ])];
            case 1:
                _a = tslib_1.__read.apply(void 0, [_b.sent(), 8]), config = _a[0], permissions = _a[1], entitlements = _a[2], catalog = _a[3], user = _a[4], listedDashboards = _a[5], accessibleDashboards = _a[6], legacyDashboards = _a[7];
                batch = redux_batched_actions_1.batchActions(tslib_1.__spread([
                    backendCapabilities_1.backendCapabilitiesActions.setBackendCapabilities(backend.capabilities),
                    config_1.configActions.setConfig(config),
                    entitlements_1.entitlementsActions.setEntitlements(entitlements),
                    user_1.userActions.setUser(user),
                    permissions_1.permissionsActions.setPermissions(permissions),
                    catalog_1.catalogActions.setCatalogItems({
                        attributes: catalog.attributes(),
                        dateDatasets: catalog.dateDatasets(),
                        facts: catalog.facts(),
                        measures: catalog.measures(),
                    }),
                    listedDashboards_1.listedDashboardsActions.setListedDashboards(listedDashboards),
                    accessibleDashboards_1.accessibleDashboardsActions.setAccessibleDashboards(accessibleDashboards),
                    legacyDashboards_1.legacyDashboardsActions.setLegacyDashboards(legacyDashboards),
                    executionResults_1.executionResultsActions.clearAllExecutionResults()
                ], stateInitializers_1.actionsToInitializeNewDashboard(config.dateFilterConfig), [
                    dateFilterConfig_1.dateFilterConfigActions.setDateFilterConfig({
                        dateFilterConfig: undefined,
                        effectiveDateFilterConfig: config.dateFilterConfig,
                        isUsingDashboardOverrides: false,
                    }),
                    ui_1.uiActions.setMenuButtonItemsVisibility(config.menuButtonItemsVisibility),
                    renderMode_1.renderModeActions.setRenderMode(config.initialRenderMode),
                    dashboardPermissions_1.dashboardPermissionsActions.setDashboardPermissions({
                        canViewDashboard: true,
                        canShareDashboard: true,
                        canShareLockedDashboard: true,
                        canEditDashboard: true,
                        canEditLockedDashboard: true,
                    }),
                ]), "@@GDC.DASH/BATCH.INIT.NEW");
                event = dashboard_1.dashboardInitialized(ctx, undefined, [], config, permissions, cmd.correlationId);
                return [2 /*return*/, {
                        batch: batch,
                        event: event,
                    }];
        }
    });
}
function initializeDashboardHandler(ctx, cmd) {
    var dashboardRef, result, e_1;
    return tslib_1.__generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                dashboardRef = ctx.dashboardRef;
                _a.label = 1;
            case 1:
                _a.trys.push([1, 9, , 11]);
                return [4 /*yield*/, effects_1.put(loading_1.loadingActions.setLoadingStart())];
            case 2:
                _a.sent();
                result = void 0;
                if (!dashboardRef) return [3 /*break*/, 4];
                return [4 /*yield*/, effects_1.call(loadExistingDashboard, ctx, cmd, dashboardRef)];
            case 3:
                result = _a.sent();
                return [3 /*break*/, 6];
            case 4: return [4 /*yield*/, effects_1.call(initializeNewDashboard, ctx, cmd)];
            case 5:
                result = _a.sent();
                _a.label = 6;
            case 6: return [4 /*yield*/, effects_1.put(result.batch)];
            case 7:
                _a.sent();
                return [4 /*yield*/, effects_1.put(loading_1.loadingActions.setLoadingSuccess())];
            case 8:
                _a.sent();
                return [2 /*return*/, result.event];
            case 9:
                e_1 = _a.sent();
                return [4 /*yield*/, effects_1.put(loading_1.loadingActions.setLoadingError(e_1))];
            case 10:
                _a.sent();
                throw e_1;
            case 11: return [2 /*return*/];
        }
    });
}
exports.initializeDashboardHandler = initializeDashboardHandler;
//# sourceMappingURL=index.js.map